module.exports = __webpack_public_path__ + "img/opengl-animation-screenshot.8de06306.png";